var exports = {
  "popup-triggers": "x31de4314--103ae6--popup-triggers",
  "popup-actions": "x31de4314--103ae6--popup-actions",
};

module.exports = exports;
